module.exports = __webpack_public_path__ + "static/media/Apple Watch 38mm Rose Gold Aluminum + Midnight Blue Open.f85bd91e.png";